import React from "react";
import "./TutorialModal.css";

function TutorialModal({ isOpen, onClose, onNext, title, content, buttonPosition }) {
  if (!isOpen) return null;

  // Se buttonPosition è fornito, posiziona il modal assolutamente sotto i bottoni
  const customStyle = buttonPosition && buttonPosition.top !== undefined && buttonPosition.left !== undefined
    ? {
        position: 'absolute',
        top: buttonPosition.top + 10,
        left: buttonPosition.left,
        transform: 'translate(-50%, 0)',
        zIndex: 2001,
        margin: 0
      }
    : {};

  return (
    <div className="modal-overlay" style={buttonPosition && buttonPosition.top !== undefined ? {position:'absolute',inset:0,zIndex:2000} : {}} onClick={onClose}>
      <div className="modal-content" style={customStyle} onClick={(e) => e.stopPropagation()}>
        <div className="modal-arrow"></div>
        <h2>{title}</h2>
        <div className="modal-body">{content}</div>
        <div className="modal-actions">
          <button className="btn secondary-btn" onClick={onClose}>
            Chiudi
          </button>
          <button className="btn primary-btn" onClick={onNext}>
            Avanti
          </button>
        </div>
      </div>
    </div>
  );
}

export default TutorialModal;
